import { useQuery } from '@tanstack/react-query'
import dashboardApi, { DashboardFilters, DashboardResponse } from '../services/dashboardApi'

const mockDashboardData: DashboardResponse = {
  fleet: [],
  notNormalSamples: [
    {
      product: 'Engine Oil 15W-40',
      productColour: '#f9a825',
      customer: 'Komatsu Mining',
      site: 'Pilbara',
      unit: 'PC450-8-001',
      unitId: 1001,
      unitHours: 8420,
      model: 'PC450-8',
      serial: 'KMTPC450A001',
      component: 'Engine',
      sampleNumber: 900001,
      alertStatus: 'Caution',
      alertRank: 2,
      componentFluidTypeId: 1,
      alertColour: '#f9a825',
      fontColour: '#000000',
      approved: new Date('2026-09-01'),
      sampled: new Date('2026-08-28')
    },
    {
      product: 'Hydraulic Oil ISO 46',
      productColour: '#d32f2f',
      customer: 'Komatsu Mining',
      site: 'Hunter Valley',
      unit: 'WA500-8-014',
      unitId: 1002,
      unitHours: 6155,
      model: 'WA500-8',
      serial: 'KMTWA500B014',
      component: 'Hydraulics',
      sampleNumber: 900002,
      alertStatus: 'Critical',
      alertRank: 1,
      componentFluidTypeId: 2,
      alertColour: '#d32f2f',
      fontColour: '#ffffff',
      approved: new Date('2026-09-02'),
      sampled: new Date('2026-08-30')
    }
  ],
  samplesInProgress: []
}
const isLocalhost = window.location.hostname.includes('localhost')

export const dashboardQueryKeys = {
  all: ['dashboard'] as const,
  detail: (filters: DashboardFilters) => [...dashboardQueryKeys.all, filters] as const
}

export const useDashboard = (filters: DashboardFilters = {}) => {
  const useMockData = isLocalhost

  return useQuery({
    queryKey: dashboardQueryKeys.detail(filters),
    queryFn: () =>
      dashboardApi.getDashboard(filters).then(data => {
        if (useMockData) {
          return {
            ...data,
            notNormalSamples: mockDashboardData.notNormalSamples
          }
        }
        return data
      }),
    staleTime: 60 * 1000
  })
}
